import { render, staticRenderFns } from "./ClicksChange.vue?vue&type=template&id=29bdf53c&scoped=true"
import script from "./ClicksChange.vue?vue&type=script&lang=js"
export * from "./ClicksChange.vue?vue&type=script&lang=js"
import style0 from "./ClicksChange.vue?vue&type=style&index=0&id=29bdf53c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bdf53c",
  null
  
)

export default component.exports